import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Form, Label, Button } from 'semantic-ui-react';
import * as styles from './SignupForm.less';

const SignupStepThree = ({
  handleBlur,
  handleChange,
  values,
  errors,
  touched,
  nextStep,
  disabled,
}) => (
  <Fragment>
    <Form.Field>
      <label>Set up your password:</label>
    </Form.Field>
    <Form.Field className={styles.formField}>
      <Form.Input
        name='password'
        type='password'
        onBlur={handleBlur}
        value={values.password || ''}
        onChange={handleChange}
        className={styles.inputOffset}
        placeholder='At least 6 letters'
      />
    </Form.Field>
    <Form.Field>
      {errors.password && touched.password && (
        <div className={styles.validationErrorWrapper}>
          <Label className={styles.validationError} color='red' basic pointing>
            {errors.password}
          </Label>
        </div>
      )}
    </Form.Field>
    <Form.Field>
      <label>Confirm password:</label>
    </Form.Field>
    <Form.Field className={styles.formField}>
      <Form.Input
        name='passwordConfirm'
        type='password'
        placeholder=''
        onBlur={handleBlur}
        value={values.passwordConfirm || ''}
        onChange={handleChange}
        className={styles.inputOffset}
      />
    </Form.Field>
    <Form.Field>
      {errors.passwordConfirm && touched.passwordConfirm && (
        <div className={styles.validationErrorWrapper}>
          <Label className={styles.validationError} color='red' basic pointing>
            {errors.passwordConfirm}
          </Label>
        </div>
      )}
    </Form.Field>
    {/* <Form.Field>
      <label>Add test credits for 99$ & get 30 tests instead of 10:</label>
      <p>
        This is one-time offer that's only valid during sign-up.
        <br />
        You are free to skip this step.
      </p>
      <a style={{ fontWeight: 'bold' }}>Add test credits now.</a>
    </Form.Field> */}
    <Form.Field>
      <Button
        onClick={nextStep}
        disabled={Object.keys(errors).length !== 0 || disabled}
        className={styles.signUpButton}
      >
        Continue
      </Button>
    </Form.Field>
  </Fragment>
);

export default SignupStepThree;

SignupStepThree.propTypes = {
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  dirty: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  setFieldValue: PropTypes.func,
  nextStep: PropTypes.func,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/views/components/SignupForm/SignupStepThree.js